module.exports = __webpack_public_path__ + "img/oper_icon.cb03150a.svg";